import { FooterContain } from './Footer.styles';

export function Footer({ title = 'Title' }) {
	return <FooterContain>{title}</FooterContain>;
}
